<template>
    <v-card>
        <v-card-text class="py-8">
            <div class="pb-6 text-center">
                <v-progress-circular
                    :rotate="-90"
                    :size="130"
                    :width="15"
                    :value="progressUploadPresentation"
                    color="#2690cb"
                >
                    <span
                        class="font-weight-500 black60--text"
                        style="font-size: 16px"
                    >
                        {{ liveClassTotalCheckRow }}/{{ liveClassTotal || 0 }}
                    </span>
                </v-progress-circular>
            </div>

            <div
                class="font-weight-500 black--text text-center"
                style="font-size: 16px"
            >
                Mohon menunggu, data sedang di proses
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    props: {
        liveClassTotal: { type: Number, default: 0 },
        liveClassTotalCheckRow: { type: Number, default: [] },
        progressUploadPresentation: { type: Number, default: [] },
    },
    name: "DialogUploadProgress",
};
</script>



// WEBPACK FOOTER //
// DialogUploadProgress.vue?5bf7adf3